{
    "schema": "ft.named-icon-names.v1",
    "generated_by": "tools/probes/n4c_named_icon_names.php",
    "names": {
        "018F9A3D-E3AF-ECBE-AE14-7781C5AE849C": "Acropolis Citadel",
        "01B0F693-7D8A-C588-9B34-CD1F323D8433": "Shielded 10",
        "02FFED44-7A58-4EF2-EF07-2FFD980A3049": "Natural Weapon (min skill tier 14)",
        "04494E0F-FD0B-B2E7-3E15-94922127ADA2": "Sun State Sunrise",
        "04C9B518-EFE2-578C-6B35-536B84538C2D": "Blood Of The Pyre",
        "04F77A14-C227-1D47-B487-46C14A75695C": "Barber Dentist Surgery",
        "0700727F-6C9E-4631-1140-B57A8E442137": "Draconic",
        "0811463E-C4F6-72F5-791C-E8CA97F730EE": "Core Of The Pyromechanist",
        "0831E19B-EB88-2B7E-DC7E-55739032AEAF": "Stringed Bow",
        "088D272A-90C4-738E-A49B-621FB95046CF": "Manifestation Of Pyrokinesis",
        "08B1A969-4874-61C8-41FD-C86A39A780D6": "Oath Of Vengeance",
        "090BED9F-3D77-FD4E-114C-3CA2963C896C": "Core Of The Voltaic",
        "0A9A7DD9-6446-41B4-959E-82C3F965E6F5": "Training In Juggernaut",
        "0B3A4002-A031-7DCB-6E61-0F604311B485": "Conclave Of The Bounty Hunter",
        "0BB1AF70-531F-5635-DB98-79FF1B815AC8": "Memorial War Memorial",
        "0C569B27-1F4C-AE8D-F3C6-19F4241557CD": "Craftsman Tanner",
        "0DBBBB72-BEAF-DD44-7903-8D37BE097B12": "Hill Location",
        "0DFDEEF9-B497-2E86-F425-C772528B1ED7": "Blade Of The Vanishing Edge",
        "0E819470-A8D6-FB8F-F1AE-74AFB05BC777": "Core Of The Graviturge",
        "0E85B423-C980-04E1-D7BE-B3F87A8934F2": "Patron Of Chance",
        "107529B3-B41B-1595-A83B-4A2F981819AE": "Blade Of The Eidolon",
        "11CFEA10-2B51-15D7-C40D-2B985A50A921": "Blade Of The Grimoire",
        "11DCFC7B-887A-7FD3-8423-DFC5B16AD336": "Song Of The Celestial Choir",
        "135EB0F1-BBAD-F5D3-28C1-9C4E6D019051": "Specialist In Assassination",
        "1364260D-E37C-4257-AD16-5E745107811A": "Melee Weapon Type",
        "139AFF5A-528C-A922-5436-5A2852C82F90": "House Large",
        "14B166A9-668E-204D-A675-B76B0979442D": "Study Of Time",
        "156DBFAC-2D11-5257-0AD1-619760D890CD": "Natural Armor Reaction (Skill Tier 7+)",
        "16A53E58-027B-DF11-6AC5-72CA13B6583A": "Orcish",
        "16E69F5F-9D8C-4C81-F492-5008E7CCA0A5": "Patron Of Secrets",
        "1794E87A-4330-59B0-ED7D-F3BBDE99FBF4": "Tower Water",
        "1ADB2848-6D7C-16F5-6681-234232DC13EC": "Trail Of The Artillerist",
        "1B619AAA-2B41-1F33-DD39-BC6B7CFF6D3A": "Forest Boreal Coniferous",
        "1B8B2014-FFFD-F7EF-BC80-B9A495B50DD2": "Vessel Of Spirits",
        "1B912A78-2334-D265-2674-7AD764534D56": "Blighted 2",
        "1C3122FE-AFA6-4FB1-9E36-AACAC3FB19A7": "Conclave Of The Dragon",
        "1C5AB5E5-45E3-D088-375C-6206CE3A26BB": "Natural Armor Reaction (Skill Tier 5+)",
        "1DA56AF8-0D7A-4137-BE12-1142CC7BB78A": "Song Of The Dancer",
        "1DEE12B6-D23A-7470-812E-CE4C77AAD395": "Maimed 8",
        "1DF25B9D-33A7-CDA5-9EB4-9A98C3407241": "Observatory Telescope",
        "1E05A4A2-6B1C-1F0D-1A65-17E83C04EBBC": "Core Of The Venomworks",
        "2050C757-11AC-12E0-BCFC-E921ABBC499E": "Song Of Color",
        "2122A0BD-C175-EF9A-D84D-750D301BD4F4": "Faith In Life",
        "21322959-44EA-0157-CBC8-91A7EDE778C6": "Forest Cloud Water Subtropical",
        "2189DD55-92A3-B8FE-DAF7-DBE01D9AF9D7": "Chasm Underwater",
        "21CB6BFF-BCCA-98A1-816E-29D96A867ECA": "Shopping Mall Commercial Complex",
        "21F13AF0-6DD9-E792-E115-DD6A4E54A7B9": "Oath Of The Spellbreaker",
        "2257ADAA-6B83-4DAF-7D99-5D2AEA180562": "Patron Of The Void",
        "225A6BFB-98F3-08CD-EA80-A8ABB6473365": "Study Of Illusion",
        "22CC3970-0458-63CA-3D69-82A746B9A5CD": "Nagh",
        "22E33A8E-DF5D-2596-8E2D-0E8A8528E47C": "Moderate Bleeding",
        "23805AB3-9F2D-29EF-A7FD-A446638C8ED2": "Warehouse Granary",
        "24493929-317B-30CE-398D-23030C0586DD": "Refinery Industrial Complex",
        "246C5FEC-3852-73BA-08C4-2C6BA3D0AFEE": "Tower Mage",
        "2533E837-2DF5-29F7-2E08-5F287D8A1A6C": "Atoll Underwater",
        "26239004-79F7-DF41-C6AD-B3D9AA565B6C": "Trail Of The Berserker",
        "26BF8308-1F2B-656E-FF25-9EB2D1E0EEE0": "Double Bladed Scimitars",
        "271C80EB-50B8-A067-A07B-5B8D89248F60": "Vessel Of Restoration",
        "27B5484B-ACFC-87A7-B2B4-E549E405B506": "Cabin Lodge",
        "281738CB-A6F8-5C43-FA15-464DEC6030C2": "Natural Armor Reaction (Skill Tier 14+)",
        "2840646C-3F3C-D38C-DE73-39ED914B01BF": "Specialist In The War Jester",
        "28A29340-0491-F2E2-229E-757B0412DF51": "Manifestation Of Clairvoyance",
        "294AB63D-0E01-A8C4-D936-30A0FC055F36": "Tao Of The Cloudrunner",
        "298BE1DD-2917-476E-D79C-92CF8C598926": "Well Bloodied",
        "2A63EC91-E5B1-17B4-DFB0-199F9E2084A5": "Shielded 9",
        "2BBC1E4E-5A42-41A4-8392-2C755D7A3C7C": "Ranged Weapon Type",
        "2C0178B2-6D28-CFA7-729C-9C774BEF8D45": "Faith In The Storm",
        "2C96B6CF-0B79-1C4D-A414-FEA6A7BEC8AB": "Mountain Location",
        "2CB279E7-CD79-1A21-9F32-89184886D7FC": "Primordial",
        "2D67C292-177A-C7C1-8278-275AACE6DC3D": "Trail Of The Takedown",
        "2D69106B-82C5-D88E-AEFD-A88B6D3F0E3B": "Coast Shore",
        "2D9328A2-9707-F14F-33E5-2C99BBA29AFA": "Spring Location",
        "2DDC4440-C14A-2F83-F418-5B85B96348E8": "Ship",
        "2E902352-952D-7E5C-8607-5DC99C9DDD21": "Estuary",
        "2F81920D-CDB8-8183-E3BC-C6DA16337C60": "Manifestation Of Metamorphosis",
        "3090FD9D-D14C-555E-19A2-D18E6A4A692D": "University Educational Complex",
        "3098C163-7B26-7757-24F1-129C467D5BDB": "Gnomish",
        "313B4B34-2D4D-7632-9BF3-05D91298AF59": "Grove Of The Swamp",
        "327BD65F-5AE8-F70F-4FFE-5FB3D50EB858": "Training In The Dragoon",
        "32C6C141-FBDB-45AF-85EA-7232284EBEC0": "Trail Of The Shatterguard",
        "32F40024-F4CF-4395-A1F9-2606CBDFE7EE": "Blood Of The Shadow",
        "331C8511-F8A7-4626-AF17-48FAF062FE50": "Fate Card Suit Love",
        "34987D5C-BB13-7633-E28A-C3DA4BD458A7": "Fate Card Suit Prosperity",
        "34CEB0D1-1DE2-03F7-BB8A-834BF8F3565A": "Natural Weapon (min skill tier 9)",
        "3503983E-A71B-6529-4002-67CEBF961607": "Coral Reef Platform",
        "36B68995-C875-199D-20E8-1A1098F846B0": "Blighted 6",
        "36DA5B89-CA08-3940-E798-FCAE6BE775D5": "Shielded 2",
        "36F16EF2-FC9D-57DD-DE24-D44469C1CBAC": "Hospitality Motel",
        "39E2635A-195A-B8B9-F7DD-1DA4E0EC53F6": "Faith In Heresy",
        "39EBAEF7-1ED7-5AAF-E88B-8C50B96B5ED8": "Natural Weapon (min skill tier 5)",
        "3B42EAFA-8DD1-CCF6-7CD3-6E19C57C0A4B": "Blade Of The Spellbreaker",
        "3D86CCB6-1E36-1588-7CA5-8C0DE846849A": "Faith In Karma",
        "3DB34758-2756-C99A-CC8D-7F9ABA230161": "Faith In Self Sacrifice",
        "3E3F2F87-5740-AA09-79C1-CD0A0599BEA4": "Patron Of The Deep",
        "3F5E1288-D9E3-4B24-8985-333404AF172D": "Grove Of The Skinwalker",
        "40E0CACB-0625-3162-EE26-5A18BD63838E": "Mind Of The Hallucinarch",
        "4172601E-FA34-6702-01F6-42BBE5EACCD1": "Theatre Concert Hall",
        "4191B743-01A5-4E81-806C-E77E0478A2F5": "Patron Of Death",
        "422E4A30-0ECD-77A3-095F-B8F3972F3689": "Racing Track Hippodrome",
        "42728623-5523-5986-672E-9A9FE5DD35B5": "Elvish",
        "430F1BE4-6522-4468-8E27-426B23D003BF": "Judgement 1",
        "4350D01A-56C5-CA6F-BCC1-32D6C2117F46": "Jeweler Building",
        "445E960B-817E-EDBB-995C-44EDFBB7B65D": "Vessel Of Cataclysm",
        "44D4504C-9BD5-0B65-F8E2-6DC4A0F820B4": "Maimed 7",
        "45122975-6514-4CE0-9484-A874CE211016": "Double Concentration",
        "459A0C3F-3089-2CC8-1BAB-0B05E66D7A96": "Blood Of The Fey",
        "4659B268-8213-6C36-81DB-39877F546282": "Manifestation Of Telekinesis",
        "46F27428-2B73-50F7-6F0C-D4FAFDB753ED": "Maimed 3",
        "4767BD78-9829-6FC9-BD4A-5855F322CEB7": "Ignan",
        "4992C4FD-7882-DBB9-BE7C-0BA4157A438A": "Study Of Abjuration",
        "4A5172E6-6D97-3958-C65B-F0792A660B85": "Enochian",
        "4A5F251A-EADE-4E22-AA84-28B796B84121": "Trail Of The Untamed",
        "4AEF8F40-B779-C0AD-4455-2DABE7B1D14B": "Maimed 9",
        "4C10C158-5474-4B43-AE85-058806DF3017": "Conclave Of The Marksman",
        "4C761395-2532-3F23-7CBA-CA81AF5C0855": "Close (30)",
        "4D27433B-6F72-47BB-9A60-B80493F22D65": "Maimed 4",
        "4D7CFE7B-DBD0-9DBC-7933-D04E9A04C389": "Specialist In The Astral Grift",
        "4DF9E59E-1BE3-105A-277D-E7A87EE79C5D": "Training In Fey Archery",
        "4E0E0C0F-3AC5-62E5-2ADD-3A7B0E1D9691": "Cafe Tearoom",
        "4FB12CDC-6812-18FA-95E4-044A9EE66F50": "Shop Tailor",
        "5479CD63-381D-321E-8FCF-894691D324F0": "Manifestation Of Telepathy",
        "54D69C32-CE87-25D7-A8B9-D3FF8008CE06": "Grove Of The Waterway",
        "5522DAD4-54BB-496D-D97E-01B25891EEC9": "Blade Of The Witcher",
        "55C4EEFF-1638-18E4-662F-E028BD91E853": "Plane Of Existence",
        "55CE51A8-D8A4-A2FE-2B93-D5C3B1C43884": "Blood Of The Artifical Soul",
        "57414350-DAC7-AD98-83CA-2C455D92007E": "Mind Of The Metamorph",
        "57A4EE67-0F3F-C4F2-CA4B-F81D896F4975": "Coral Reef Atoll",
        "57E18214-3561-D675-C8A8-60A20FA09BC7": "Oath Of Revolution",
        "57F117E8-6659-4F2D-AED2-82D6005492B9": "Divine Sphere of Magic",
        "582DB613-DDBA-458F-20D0-298BB278854A": "Faith In Light",
        "59691E2F-1807-5582-91E4-D65E5E6EA167": "Volcano Underwater",
        "5A62FC7D-79E4-A7B0-244F-18D865FD5679": "Coral Reef Barrier",
        "5AE6E8F3-89E6-5D5C-DE25-D30B573B08C3": "Tao Of The Southern Star",
        "5C346F0F-D58D-2859-92EB-A347FA56899E": "Dwarvish",
        "5C557D5A-B85F-DF45-3CF6-6739D2BD70EC": "Maimed 6",
        "5CB84B6E-E636-B4A3-3864-910DBD3B63B4": "Blighted 1",
        "5D90B5B1-5AF4-4365-6468-2697BE57BFD2": "Song Of The Sea",
        "5E22CB3D-7815-16A0-C9EB-D28DA5D6B263": "Crater",
        "5EEA5A21-4FCC-884C-ED46-370AFE880209": "Study Of Conjuration",
        "5FF654D1-19D8-4055-B1AB-06F5A0044806": "Song Of The Vocalist",
        "60ED1493-67CD-6715-BE15-FE74DEE26DCE": "Apothecary Building",
        "61C890AE-1120-24BA-481D-B19875C9EB92": "Tao Of The Ten Thousand Limbs",
        "621BEEDA-119E-5B7B-54A9-186C926C615D": "Blood Of The Angel",
        "62471733-E4AA-40FB-551B-1AD623740861": "Blade Of The Chronoknight",
        "631AAD91-F6A5-879D-5BD6-B7F885AA7FC9": "Shielded 7",
        "6372D1C5-6BB9-41A5-BFD0-885C852005F4": "Tao Of Senjing Ganrao",
        "641E712F-1B60-C633-14BF-C4EE0DDD4AF4": "Qini",
        "64958272-483E-EEA4-EE07-A945F2A8F62A": "Shop Magic",
        "64E8A3F8-45B0-7D29-0F43-BFB208F654FF": "Ghost Train",
        "655383C0-8B0C-3B33-694D-26404400626D": "Blighted 5",
        "65A6036B-F6A6-811B-F85E-86F512B74EA2": "Vessel Of Stars",
        "67EFA62C-3A5C-9FEE-D54D-EF7615C063F4": "Light Hammers",
        "68781B19-86F0-8233-4F14-F1DE713BE79A": "Trail Of The Reaver",
        "68F4DF94-3345-74AF-EC27-4CCA564D4333": "Grove Of The Infestation",
        "69C3F7FB-2FE5-21A1-04DE-636C9B3387D1": "Hospitality Resort",
        "6A31B8DA-8AD6-ACC1-9E3A-3A8DD77FD43D": "Fate Card Suit Change",
        "6A43A001-E717-DE2A-E533-944C20F70C77": "Plate Armors",
        "6AB76ADB-22BC-904A-7D72-43FDCA112DD1": "Grel",
        "6ADDE9C0-261B-C011-826F-E8B6522414A3": "Grove Of The Desert",
        "6EEF7655-4FC7-F5F4-0AB8-C31C31FEEDCD": "Domir",
        "6FD9898C-F2F7-0D60-6E80-2CE855ABD6A7": "Training In Bushido",
        "70863B88-1DB2-4464-AF5C-542B251E6013": "Tao Of Ninjitsu",
        "70A2ABCA-C777-3887-9A7D-2B77EF757EC4": "Help",
        "7134B17B-8B7E-2EF2-B33B-14DAE18514F4": "Vessel Of Aegis",
        "718E7C4E-3E8A-F95E-5CAF-932984CCF213": "Desert Ice",
        "71C75E03-B9EA-0F1B-226E-0D0139966268": "Song Of Discord",
        "7205CA73-B3EC-4C17-B346-7A8CD381DEF9": "Patron Of The Artifact",
        "7257525A-37A8-9DCE-1656-C7449FF2C305": "Heavy Crossbows",
        "7359FA1C-9C72-A490-A7BA-D9AA25CEB1EC": "Dimensional Pocket",
        "73786439-62A8-4226-99CB-419E32D119C0": "Blood Of The Oracle",
        "73BB4DD3-386E-B2D0-B172-49968B3F3769": "Training In Precision",
        "7449B08F-F68C-0003-239C-BB821BD485D7": "Study Of Transmutation",
        "7554CE49-B27C-11F1-8C29-61872DCF8F69": "Gulf Lagoon",
        "76066F6C-B169-3025-E3C0-9DEA1A55CDA4": "Monument Statue Large",
        "7650DB9F-465F-DDA6-9D7E-E064F4BC910F": "Sun State Day",
        "768F7512-7D3E-6E90-8E91-72DC66A0089B": "Forest Temperate Seasonal",
        "77371A15-CD6D-8215-2B47-F7DA63CE291D": "Tower Wall",
        "77D5AFC0-C991-B98A-2AD9-6922ED094BF7": "Half Plate Armors",
        "799A2ACC-2532-DBDC-6458-7F487CD8EE60": "Blood Of The Dragon",
        "7A93E220-3578-5912-3856-B0160E9A0856": "Bank Treasury",
        "7AAA3989-0233-88C9-5A1A-3F89923B6192": "Planetoid Moon",
        "7BA5009E-B362-AE2F-ABB6-D06D54D306EA": "Sun State Sunset",
        "7BAF9F56-B8FF-4FBE-886F-30F055A568B3": "Faith In Fate",
        "7C078D1C-6763-AB35-356C-7B3B38158541": "Blade Of The Shade",
        "7D77CBED-1030-882D-64D9-C53F8BD7CD18": "Core Of The Dissolver",
        "7E0421DF-EA86-90AA-E95D-30145B3F43BD": "Natural Weapon (min skill tier 1)",
        "7F03B43E-A5CA-E4DA-0E74-957AAE7EF494": "Well Large",
        "7F372EFE-7AEA-6E06-9748-B8F815748CA9": "Study Of Divination",
        "7F640E10-E070-C716-5ED1-A5AA5D2C6971": "Grove Of The Void",
        "7F6E7D26-77CE-801A-51F7-1CEE17153C70": "Natural Weapon (min skill tier 3)",
        "7F938839-F44A-FA43-05FA-BAAF79B7A05B": "Blighted 3",
        "814E499E-5294-679B-65B4-B4A8D5DAA5C0": "Oath Of Honor",
        "81DADED4-7909-482A-BE32-76887642C172": "Common",
        "8209208D-478B-C896-B674-E52D34497C9C": "Conclave Of The Construct",
        "820AB0A3-F21A-3135-DB75-89DCDF09A9D0": "Aquan",
        "8346CCFF-3A5B-F0E4-CFDE-6CF1D1ED3368": "Shielded 3",
        "83E39FC7-66BB-B09B-7990-71437A0493C6": "Mind Of The Pyrokinetic",
        "84CDEE1D-44C2-AE0C-B5AF-BF79CF08D91F": "Tao Of The Blooming Fang",
        "87B3915B-F40A-C2A9-678B-1D1508ACBCED": "Blade Of The Valkyrie",
        "87C01352-EAA6-E667-8C9E-DE24D563320F": "Planetoid Rogue",
        "88B5DA41-090D-4528-8A11-761851166F0F": "Brewery Winery",
        "88F0C54B-9B37-9B57-7F5D-D117B73E70BA": "Lake Dry",
        "8A3B8D76-ED7A-560A-166D-73093DE6F4E9": "Blighted 9",
        "8AC31F16-0DC8-7FEB-FBE6-8139CBC59FE7": "Tao Of The Dragon Warrior",
        "8B08E0D0-BB18-6B35-32B6-A563A345D1E1": "Patron Of War",
        "8BBE01F6-13CC-727F-4431-9B66CD3BB7BA": "Patron Of The Fey",
        "8C25C0CD-AF02-6648-A158-87F4DEBB8651": "Light Crossbows",
        "8C5E6FE2-A769-097B-42DF-C704A99FA567": "Tower Telecomms",
        "8C6BC8F9-F7E3-6F7D-22DD-06D3760366A6": "Oath Of Love",
        "8D0D4656-28B2-9160-43AA-BF379D5F5369": "Vessel Of Evolution",
        "901C6A86-F359-A99F-1D63-4CDA0F040210": "Apartment Building Tenement",
        "90D143BD-9CC9-06F7-F339-03F50C27D958": "Blighted 8",
        "90FB0BFB-6186-5E01-FD8B-0315D6DFB809": "Judgement 3",
        "9154FF1F-721A-2BCA-1AEF-24AC7B32FE4B": "Maimed 2",
        "92CB1BB5-DF5F-CD84-A2AF-4EE1B85781B5": "Song Of Knowledge",
        "941C9CE1-2262-0D92-4448-0C309A0440DB": "Conclave Of The Ooze",
        "9437F344-1461-B4C0-E196-6BA1A34ADC94": "Maimed 1",
        "9441BB9E-7252-51FD-4385-835709322AC3": "Training In The Duelist",
        "9490C429-4FDA-E669-390C-C6798696F312": "Train",
        "94D1A00F-4795-B1DD-6981-6CE3364AF1B3": "Druidic",
        "952D01EA-8A43-3DEF-BB12-E4F6DD69FD45": "Hydroponics Agricultural Complex",
        "95968E76-2744-E42F-8FC5-026EDF34249A": "Patron Of The Devil",
        "96E272A4-8DDE-443C-0FCF-3A24ECFFB7C2": "Arcane Sphere of Magic",
        "972AD871-F294-5894-9BAB-2A3B12A6646B": "Patron Of The Angel",
        "9758A401-365F-8AD2-329C-B124B000C8E2": "Hospitality Hotel",
        "97914953-9682-C3BC-7BEE-A02846D689F9": "Underground Subterranean",
        "9C58554D-BA6C-BE4C-30A0-B8A384DC5C38": "Grove Of The Heavens",
        "9CA1E148-712D-322B-DBFC-3EF6F18A300D": "Tao Of The Painted Shell",
        "9D7BAB5B-5197-318A-4D96-EF05580BC8AF": "Planar Sphere Grouping",
        "9DDD6B5D-BAE3-3989-1DF6-D2060DCD1B8F": "Faith In The Spirits",
        "9DF0BF22-2C59-D288-6E7A-E0708737BCD3": "Trail Of The Painbearer",
        "9EFD0898-7C92-6DE4-DD2F-D6F75ECF3B58": "Judgement 2",
        "A0BC86C5-403E-1034-B759-1292FA2403A8": "Coral Reef Fringing",
        "A0DC40FE-BA7A-89FC-CA10-1C15BBAD6EDF": "Armor Size: Titantic",
        "A17E1321-2CCD-7C70-9F00-DA261C138F0F": "Desert Location",
        "A230F5E6-B6AD-8091-4F59-5E454776B4FA": "Maimed 10",
        "A41E445E-9884-958E-BE93-87F33A1F44F8": "Patron Of The Djinn",
        "A5B19883-CBDA-EC46-A859-96FF01651278": "Abolian",
        "A67BE9E8-392C-FAD1-4C84-8C9C8ECAB0CB": "Oath Of The Stars",
        "A773884A-CAD6-76CB-5DCE-F025A6D91931": "Shop Cobbler",
        "A831D8E0-4DC5-4FBF-4A4C-2C9955AE230A": "Shielded 6",
        "A8FAE765-7F06-7AF6-C452-6D80086C1B6D": "Natural Armor Reaction (Skill Tier 9+)",
        "A95F219A-6288-6B17-6DB7-03DE4B97AE96": "Near (60)",
        "AB7DEAAE-62BF-4996-A510-5F2B192F8F14": "Natural Weapons",
        "ABAE4F65-1A42-DEFC-21C8-11EBF883A484": "Umbral",
        "ACA3E968-C358-FCC5-0EBA-42E2068C200F": "Shop Generic",
        "AD81DE70-D93B-FCCC-042A-379B252246E1": "Specialist In Thievery",
        "AF3FA968-2776-CF37-AAB8-7B7E4BAC555B": "Patron Of The Lich",
        "AF821625-3E60-79DB-28E2-67AAEB68189F": "Specialist In Espionage",
        "B068A115-A99F-30E5-8B43-A74C1DA8B6A4": "Study Of Charm",
        "B0768EB7-8EE7-500F-628D-336163307C17": "Manor House Meeting Hall",
        "B1004AD8-7CBB-9DFD-428C-721538BBBAB3": "Cathedral Great Temple",
        "B12FE4D0-480A-239A-DAF0-704850F5162D": "Abyssal",
        "B1B5365D-2DE0-AA53-A729-AC28BF8C8D52": "Auran",
        "B37A90CE-A8F4-4635-BBE2-82D651BFB955": "Mind Of The Clairvoyant",
        "B4D1AA5E-3B7B-4CE6-BA1E-DC43A5EEBF38": "Primal Sphere of Magic",
        "B516E119-A619-2C08-813B-49F9DF7FCA60": "Faith In Fire",
        "B53BC269-EB0D-725A-C7F4-5D58C717F04A": "Study Of Evocation",
        "B69522BE-88B1-058C-BABB-656071158414": "Study Of Gravity",
        "B6A69701-483A-55CF-7AAB-292237A0C10E": "Brothel Whorehouse",
        "B7006465-D7D9-57FF-83A5-83AE70D09F25": "Vessel Of Enhancement",
        "B71C82DA-CC53-C15E-9DC9-052AF2734E5F": "Laboratory Magical",
        "B818235F-3B74-E875-54F3-57BBA5D60E9D": "Faith In The Mask",
        "B8F4138E-2663-9767-998E-0FA2EAC3196F": "Gorge Rift",
        "B992A172-D3D1-4BF4-A9FB-19448D14D2D2": "Kiosk Small Store",
        "BA7A3107-1B40-D50C-A147-E3DC90E45022": "College Academy",
        "BA8ECBF1-2746-BF91-4BF1-03FBF4B09911": "Blood Of The Glacier",
        "BAAA237B-1AA7-0409-5BC7-1A6720573069": "Severe Bleeding",
        "BAF467C4-1BC3-70BB-55E4-96D8413908D5": "Vessel Of Dispersion",
        "BAFCF694-703D-6D90-C6FD-62F0B55E06E4": "Tower Guard",
        "BC71C175-ED2C-4BD2-87D4-C853CAE47D56": "Oath Of Mercy",
        "BCFE1123-F449-4A98-A4C5-1A3EEB9DF3C5": "Grove Of The Forest",
        "BDCFE0B2-7BC9-462A-878D-22886DCDC426": "Study Of Dark Necromancy",
        "BE674A0A-D7B9-DBED-A9E3-BBBA166CC831": "Forest Location",
        "BEDCAD25-AC66-B6A5-AD3E-6B4D9DAF2422": "Oath Of Purification",
        "BF1C1C48-8171-90B8-CD83-F2768348629F": "Shielded 8",
        "BF823982-6FC8-51F0-F452-5BE1C949FBA6": "Shielded 1",
        "BF94F6AD-C025-6102-C3A8-50E8FE367EC6": "Hospitality Camping",
        "C4392CC6-ED12-0278-839A-96420C0DEB7E": "Blood Of The Wildsoul",
        "C45FF93F-1106-6B2F-D6DB-25213C8F1D8B": "Lair Building",
        "C552CB52-F198-12ED-FA4E-7F60E606108A": "Supermarket Megastore",
        "C64044AF-3A5E-DE56-BB5F-5400FECD5CC0": "Ministry City Hall",
        "C6630706-C18B-AA42-BF23-58FDD517D1FC": "Training In The Sentinel",
        "C6FDF4E8-CFEC-E603-8994-496C3576E010": "Training In The Commander",
        "C8163F62-7B18-8221-A60D-C9DD775682E3": "Trackers Brand",
        "C89BAEA4-FD78-25F1-32D3-6AAB4BFBFA50": "Faith In Time",
        "C8A114DD-4380-D1C3-CFD0-F50C10B59F93": "Specialist In The Nullvein",
        "C9630A6D-D44E-4154-ADD6-FFF1FA4467AE": "Blood Of The Conduit",
        "CC1A807C-117A-5815-74F2-9C1253381F2E": "Patron Of The Plague",
        "CCE2F7CD-502B-C8AA-37D4-70FE8F416A52": "Conclave Of The Demon Slayer",
        "CDC76E93-5AD1-E80D-08C5-7B2F10080649": "Hospitality Spa",
        "CEFB07FE-0663-45C6-A532-39E1E70EE2D0": "Conclave Of The Abberation",
        "CFBFF802-8C7C-AAD7-3E02-930D012FC7BE": "Blood Of The Storm",
        "D07FEDBB-A83C-44DD-AA29-61B918DA52B8": "Mind Of The Telekinetic",
        "D1E8DA38-61C2-97AA-6173-4BF6157FEEE3": "Far (120)",
        "D1FCB683-7F8A-D179-6C01-4982234B1A10": "Specialist In Sabotage",
        "D25638CA-09AF-2722-FBA9-5074DBDE3410": "Song Of The Fey",
        "D266179F-EAD6-AAF2-EC00-EAF45679AD0B": "Natural Weapon (min skill tier 7)",
        "D267CD08-6952-99E9-B19E-52EC690546BB": "Sylvan",
        "D2FE0631-AD39-F0FA-7B69-8DE9642D54BB": "Tao Of The Drunken Master",
        "D3DE0245-0CBE-1FE3-04F8-D2BC22C9A849": "Core Of The Necroforge",
        "D5DE14C4-3194-87BC-D767-6D45BDD90552": "On Deaths Door",
        "D7C86CF3-8B6D-00EC-9308-468F0FBB2FD6": "Boathouse Wharf",
        "D9385FAD-9078-1329-C3B5-AA794CE08DCA": "Forest Jungle Tropical",
        "D9394C92-068A-FAFA-231D-289157FD2980": "Fate Card Suit War",
        "D9668790-E866-861A-FDE0-D23D2903B0FA": "Blighted 7",
        "D9903CA2-4D2C-0352-FB50-8067D5898D9D": "Conclave Of The Monstrosity",
        "DA93B17F-9205-022A-D20D-1C396719FDB7": "Specialist In Corpsman",
        "DB6A91D7-7F88-7FB2-1783-7393CF041B9C": "Song Of The Loom",
        "DC3DC1CB-1E0A-86B0-1F24-75DF34EFD580": "Mansion Villa",
        "DF593FA2-C331-4CCC-8DCD-4978D4DA77BE": "Mind Of The Telepath",
        "E0135F81-E291-0553-9FF8-0BCB67C342C4": "Grove Of The Mountain",
        "E05E77E1-F35F-12E7-111F-EB582D78C862": "Craftsman Blacksmith Smithy",
        "E11509DD-8F0F-41FB-A34F-7F9917136D7A": "Study Of Necromancy",
        "E25DE317-AB3A-45A1-AE7E-1F8F5A6C47D2": "Oath Of The Guardian",
        "E2642195-EDA0-141A-2147-77E13647D85F": "Military Base Complex",
        "E26F9653-FBDA-52BA-080B-8BBB422069CE": "Blood Of The Stars",
        "E2C8138B-8805-08A0-C8E2-C79AD86B720B": "Craftsman Leatherworker",
        "E2C8228D-A3A4-415F-26BA-AD832865C0FC": "Specialist In Piracy",
        "E4994653-49B3-D768-35C1-36C8DE40CC1A": "Maimed 5",
        "E4B7F803-C689-A9A5-0FB7-EB8D9946874E": "Sun State Night",
        "E5314BED-1269-3A65-8C15-01E80A3A8E23": "Shielded 4",
        "E54B8A46-A63F-AB3A-BAA9-C27826B0AF5F": "Bad News",
        "E614D75F-CF27-D169-3D91-0D33D9CE354B": "Shielded 5",
        "E64821CE-A9A5-D2C3-4116-8A8D5DCA4D30": "Blighted 10",
        "E64E94A5-60A7-26FF-DE15-DEA120685D00": "Police Fire Station",
        "E6CCEF87-419A-57CF-DC12-73324DB86CD1": "Hand Crossbows",
        "E73758E2-453A-B5EA-A8AE-0418702C3E90": "Core Of The Quaking Bell",
        "E75F440A-B675-0C34-AEDD-568FDAD06675": "Tavern Pub Bar Restaurant",
        "E76097FE-D47E-FD76-B7AF-8F0C40A3BCA1": "Thieves Cant",
        "E83F15DB-2FA1-991A-D117-74B0022D3338": "Grassland Location",
        "E9E1745B-7B0B-4082-BE65-72EAFEAA2CB1": "Training In The Gunslinger",
        "EAC11C79-B399-7259-8556-8EDA88B7FCD8": "Terran",
        "EB39CEE1-4B20-DDB2-3FD8-51C04BE2DB96": "Island Floating",
        "F00CE88F-4D41-A36D-8883-8C3CAFAAD744": "Temple Church",
        "F2FDFE14-A998-81D5-024E-3CF1B0B26E43": "Trail Of The Broken Limits",
        "F5E27A66-BF01-7CD2-C68E-CBE64A9F73E9": "Blood Of The Hemophage",
        "F5EE40A5-D18A-4186-82D3-E21075B43CBA": "Tao Of Gentleness",
        "F6AA8864-18EE-0140-0C65-8EEEFE2FE5E4": "Core Of The Rimeguard",
        "F6CFA733-CEBD-41EE-B357-2CCEA45FECF6": "Trail Of The Hallow Mind",
        "F6DAE84B-CBB3-5C0F-89EF-370DE841DFDA": "Very Far (240)",
        "F794E50D-95E8-A7AB-D7BD-CC2C3035CFEC": "Faith In Dreams",
        "FAFC9034-187C-4E86-926C-AF8DFBF0BE99": "Natural Armor Reaction (Skill Tier 3+)",
        "FBD22CAB-950F-8DAE-E052-65A88BF5205B": "Sign Language",
        "FBD8C681-C1CE-B2D5-9D2C-B41CFA9E16D7": "Stringed Plucked",
        "FBDDC2CF-8E49-005F-EEB7-ADBA5ECE045A": "Grove Of The Deep",
        "FC73E87B-BD88-590F-5409-8C2BDA8974A8": "Theme Park Entertainment Complex",
        "FCC88F77-777D-56B1-913E-E676C90E39E3": "Blighted 4",
        "FDC0E3EB-402E-156E-9EBD-EF8C4E2DA59C": "Tao Of The Courtesan",
        "FDDFF216-A24D-C129-BB48-DB543159B2B7": "Shard Of Korravex",
        "FF0AD09F-3CD3-3585-6D6F-AF14E13CB5AB": "Tao Of The Dancing Spider"
    }
}
